import React from 'react';
import { SectionHeader } from '../components/UI';
import { useInView } from '../hooks/useInView';
import { OUTCOMES } from '../data/courseData';
import styles from './Outcomes.module.css';

export default function Outcomes() {
  const [ref, inView] = useInView();

  return (
    <section className={styles.section} id="outcomes">
      <div className={styles.container}>
        <SectionHeader
          label="What You'll Actually Achieve"
          title="By the end, you'll be able to do <em>real things</em> — not just talk about them"
          subtitle="Every module maps to a concrete, usable skill. Here's what you'll walk away with:"
          center
        />
        <div className={styles.grid} ref={ref}>
          {OUTCOMES.map((o, i) => (
            <div
              key={i}
              className={`${styles.card} ${inView ? styles.visible : ''}`}
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <div className={styles.icon}>{o.icon}</div>
              <h3 className={styles.title}>{o.title}</h3>
              <p className={styles.desc}>{o.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
